import './ScopeItemActionButton.scss';
import { Button } from 'antd';
import { coreActions } from '@sonar-software/sonar-core';
import { CloseOutlined, DeleteFilled } from '@ant-design/icons';
import React, { useCallback } from 'react';
import { useAction, useCurrentUser } from '@hooks';
export const InitiativeScopeItemActionButton = ({ initiativeId, itemId, sonarObjectId, removeAction }) => {
    const { isReadOnly } = useCurrentUser();
    const deleteScopeItemFromInitiative = useAction(coreActions.requestDeleteCoreInitiativesSonarObjects);
    const handleOnClick = useCallback((event) => {
        event.stopPropagation();
        if (removeAction) {
            removeAction(itemId, sonarObjectId);
        }
        else {
            deleteScopeItemFromInitiative({
                initiativeId,
                sonarObjectIds: [sonarObjectId]
            });
        }
    }, [deleteScopeItemFromInitiative, initiativeId, itemId, removeAction, sonarObjectId]);
    if (isReadOnly) {
        return null;
    }
    return (React.createElement(Button, { className: 'delete-button', onClick: handleOnClick, size: 'small', type: 'link' }, removeAction ? React.createElement(CloseOutlined, null) : React.createElement(DeleteFilled, null)));
};
